import React from "react";
import LeftNav from "../LeftNav";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => {
    return (
        <>
            <LeftNav />
            <div className="ml-[68px] main-content">
                <Outlet />
            </div>
        </>
    );
};

export default Layout;
